export default __webpack_public_path__ + "static/media/trunk-closed.322ec73a.svg";